import {Nullable, ValuesList} from "../caos-def";
import ValuesListElement from './values_list';
import {SetVariantFunc} from "../utils.variants";
import {CaosLib} from "../utils.caosdef";
import React from "react";

/**
 * Render properties for the ValuesLists component
 */
type ValuesListsProps = {
    readonly caosLib: CaosLib;
    readonly setVariant: SetVariantFunc;
    readonly valuesLists: ValuesList[];
    readonly useSeaMonkeys: boolean;
    readonly validValuesListsIds: Nullable<number[]>;
    readonly pushPopupItem: (kind: string, id: number) => void;
}

/**
 * Render a list of values lists (main parent element)
 * @param caosDef CAOS definitions object, holding commands, values lists, etc.
 * @param setVariant react variant setter used when clicking variant header items
 * @param valuesLists array of values lists to render
 * @constructor
 */
export default function ValuesListsElement(
    {
        caosLib,
        setVariant,
        valuesLists,
        validValuesListsIds,
        useSeaMonkeys,
        pushPopupItem
    }: ValuesListsProps
) {

    if (valuesLists == null) {
        console.error("ValuesList list is null");
        return "";
    }

    const listElements = valuesLists
        .sort(sort)
        .map(list => {
            if (list.id == 280) {
                return ""
            }
            const key = `value-list-${list.id}`;
            return <ValuesListElement
                key={key}
                list={list}
                caosLib={caosLib}
                setVariant={setVariant}
                useSeaMonkeys={useSeaMonkeys}
                show={validValuesListsIds != null ? (validValuesListsIds.indexOf(list.id) >= 0) : null}
                pushPopupItem={pushPopupItem}
            />
        });

    return <section data-section="values-lists">
        <h2>Values Lists</h2>
        {
            listElements.length > 0
                ? listElements
                : <p className="no-matching-warning">No Matching Lists</p>
        }
    </section>
}


function sort(a: ValuesList, b: ValuesList): number {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
}
